const galleryItems = [
  {
    src: 'https://cdn.website-editor.net/7d8ac7c335184250b23ba42ef856ef8e/dms3rep/multi/8159badc-1a70-42ca-a7cd-75fc3b54ddaf.jpg',
    title: 'Balkonbau',
  },
  {
    src: 'https://cdn.website-editor.net/7d8ac7c335184250b23ba42ef856ef8e/dms3rep/multi/20181109_154010-b9c089e9.jpg',
    title: 'Metall- und Stahlbau',
  },
  {
    src: 'https://cdn.website-editor.net/7d8ac7c335184250b23ba42ef856ef8e/dms3rep/multi/2ec34235-dc1f-48ff-963f-563d3f6c3825.jpg',
    title: 'Metalldesign',
  },
  {
    src: 'https://cdn.website-editor.net/7d8ac7c335184250b23ba42ef856ef8e/dms3rep/multi/IMG_0314-dcbdb8f4.JPG',
    title: 'Industriearbeiten',
  },
  {
    src: 'https://cdn.website-editor.net/7d8ac7c335184250b23ba42ef856ef8e/dms3rep/multi/IMG_0655.JPG',
    title: 'Geländer',
  },
];

export default function Galerie() {
  return (
    <div className="min-h-screen py-16 md:py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
          Galerie
        </h1>
        <p className="text-foreground-600 text-center mb-12 max-w-2xl mx-auto">
          Eine Auswahl unserer Metallbauarbeiten. Qualität und Präzision in jedem Detail.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg bg-background-100 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.src}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <p className="text-background-50 font-semibold text-lg">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}